import {Component, EventEmitter, forwardRef, OnInit, Output, OnDestroy, Input} from '@angular/core';
import {IReasonDelay} from '../../../../core/interfaces/reasons-delay.interface';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ReasonsDelayService} from '../../../../core/services/reasons-delay.service';
import {Subscription} from 'rxjs/Subscription';
import {assignNewArray} from '../../../A2-utils/export-functions/functions-services';

@Component({
  selector: 'app-reasons-delay',
  templateUrl: './reasons-delay.component.html',
  styleUrls: ['./reasons-delay.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() =>  ReasonsDelayComponent),
      multi: true
    }
  ]
})
export class ReasonsDelayComponent implements OnInit, ControlValueAccessor, OnDestroy {
  public reasonsDelay: IReasonDelay[];
  public form: FormGroup;
  private subscrip: Subscription[] = [];
  @Output()response = new EventEmitter<number>();
  @Input()inClass = '';
  propagateChange: any = () => {};
  constructor(
    private _fb: FormBuilder,
    private _reasonDelayService: ReasonsDelayService
  ) {
    this.getReasosnsDelay();
    this.createForm();
  }

  ngOnInit() {
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this.form.get('triplatereasonid').setValue(obj);
  }
  /**
   * @description crea el form
   */
  private createForm(): void {
    this.form = this._fb.group({
      triplatereasonid: '',
    });
    this.subscrip.push(this.form.get('triplatereasonid').valueChanges.subscribe(
      (value) => {
        this.propagateChange(value);
        this.response.emit(value);
      }
    ));
  }
  /**
   * @description trae las razones
   */
  private getReasosnsDelay(): void {
    this.subscrip.push(this._reasonDelayService.getReasons().subscribe(
      (reasons: IReasonDelay[]) => {
        this.reasonsDelay = assignNewArray(reasons);
      },
    ));
  }
  ngOnDestroy(): void {
    this.subscrip.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reasons-delay/reasons-delay/reasons-delay.component.ts